(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/views/calendar.js') >= 0) return;  svs.modules.push('/modules/game-results/views/calendar.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.game_results=_svs.game_results||{};
_svs.game_results.templates=_svs.game_results.templates||{};
svs.game_results.templates.calendar = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression((lookupProperty(helpers,"component")||(depth0 && lookupProperty(depth0,"component"))||alias2).call(alias1,"calendar",{"name":"component","hash":{"title":"Välj omgång","branding":(lookupProperty(helpers,"concat")||(depth0 && lookupProperty(depth0,"concat"))||alias2).call(alias1,"calendar-",(depth0 != null ? lookupProperty(depth0,"product") : depth0),{"name":"concat","hash":{},"data":data,"loc":{"start":{"line":1,"column":65},"end":{"line":1,"column":93}}}),"class":"js-game-results-calendar"},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":115}}}));
},"useData":true});
Handlebars.partials['svs-game_results-calendar'] = svs.game_results.templates.calendar;
})(svs, Handlebars);


 })(window);